import React, { Component } from 'react';

import api from '../../../api/';

import Create from "./Create.js";
import Delete from "./Delete.js";
import Detail from "./Detail.js";
import Edit from "./Edit.js";

import ParadigmaTable from "../../../components/ParadigmaTable/"

class Casillas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: "nombre",
                    show: true,
                },
                {
                    Header: "Host",
                    id: "host",
                    accessor: "host",
                    show: true,
                },
                {
                    Header: "Usuario",
                    id: "username",
                    accessor: "username",
                    show: true,
                },
                {
                    Header: "Puerto",
                    id: "port",
                    accessor: "port",
                    show: false,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        const { action } = this.props.match.params;
        return (
            <div className="ui-form">
                <ParadigmaTable
                    buttons={[
                        {
                            create: true,
                            component: Create,
                            permission: 'config_email_casillas_add',
                        },
                        {
                            edit: true,
                            component: Edit,
                            permission: 'config_email_casillas_edit'
                        },
                        {
                            detail: true,
                            component: Detail,
                            permission: 'config_email_casillas_detail',
                        },
                        {
                            edit: true,
                            component: Delete,
                            permission: 'config_email_casillas_delete',
                        }
                    ]}
                    apiUrl={api.email.casillas.list}
                    columns={this.state.columns}
                    exportUrl={api.email.casillas.export}
                    title={"Casillas de Mail"}
                />
            </div>
        );
    }

}

export default Casillas;



// WEBPACK FOOTER //
// ./src/views/Config/Casillas/Casillas.js